import Vue from 'vue'
import { Message } from 'element-ui'

const is_null = (d) => {
    if (typeof (d) === "undefined") return true

    if (typeof (d) === "string") {//字符串
        if (d === "undefined" || d === "") {
            return true
        } else {
            return false
        }
    }

    if (Array.isArray(d)) {//数组
        if (d.length == 0) {
            return true
        } else {
            return false
        }
    }

    return false
}

// 空判断
export function inputNullCheck(val, prompt) {
    if (is_null(val)) {
        Message({
            message: prompt + '不能为空',
            type: 'error',
            showClose: true,
            duration: 1000
        })
        return true
    }
    return false
}

// 手机号验证
export function checkMobileReg(val, prompt) {
    var mobileReg = /^(?:(?:\+|00)86)?1\d{10}$/
    if (mobileReg.test(val)) {
        return false
    } else {
        Message({
            message: prompt + '格式不正确',
            type: 'error'
        })
        return true
    }
}

// 身份证号验证
export function idNumberCheck(code, prompt) {
    var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
    }
    var tip = ""
    var pass = false

    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "格式错误"
        pass = true
    } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误"
        pass = true
    } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('')
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
            // 校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
            var sum = 0
            var ai = 0
            var wi = 0
            for (var i = 0; i < 17; i++) {
                ai = code[i]
                wi = factor[i]
                sum += ai * wi
            }
            var last = parity[sum % 11]
            if (code[17] === 'x') code[17] = 'X'
            if (parity[sum % 11] != code[17]) {
                tip = "校验位错误"
                pass = true
            }
        }
    }
    if (pass) {
        Vue.$vux.toast.show({
            text: prompt + '' + tip,
            type: 'cancel'
        })
    }
    return pass
}

export function lengthCheck(data, max, min) {
    data = parseInt(data)
    if (isNaN(data)) {
        data = 0
    }
    if (data > parseInt(max)) {
        return max
    }
    if (data < parseInt(min)) {
        return min
    }
    return data
}



// WEBPACK FOOTER //
// ./src/utility/inputCheck.js